import { render } from "./cash-coupons.vue?vue&type=template&id=28f85b26&scoped=true"
import script from "./cash-coupons.vue?vue&type=script&lang=js"
export * from "./cash-coupons.vue?vue&type=script&lang=js"

import "./cash-coupons.vue?vue&type=style&index=0&id=28f85b26&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28f85b26"]])

export default __exports__